/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Local_PathInputs */



/**
* | output |
* | --- |
* | "Local Path" |
*
* @param {Local_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const local_path = /** @type {((inputs?: Local_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chemin local")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lokaler Pfad")
	if (locale === "it") return /** @type {LocalizedString} */ ("Percorso locale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Локальный путь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ruta local")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("本地路径")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ローカルパス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थानीय पथ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caminho local")
	return /** @type {LocalizedString} */ ("Local Path")
});